export const GET = 'GET';
export const POST = 'POST';
export const PUT = 'PUT';
export const DELETE = 'DELETE';

export const GET_CHAT_WIDGET_REQUEST = 'GET_CHAT_WIDGET_REQUEST';
export const GET_CHAT_WIDGET_SUCCESS = 'GET_CHAT_WIDGET_SUCCESS';
export const GET_CHAT_WIDGET_FAIL = 'GET_CHAT_WIDGET_FAIL';

export const RESET_WIDGET = 'RESET_WIDGET';

export const CREATE_CHAT_REQUEST = 'CREATE_CHAT_REQUEST';
export const CREATE_CHAT_SUCCESS = 'CREATE_CHAT_SUCCESS';
export const CREATE_CHAT_FAIL = 'CREATE_CHAT_FAIL';

export const GET_CHATS_REQUEST = 'GET_CHATS_REQUEST';
export const GET_CHATS_SUCCESS = 'GET_CHATS_SUCCESS';
export const GET_CHATS_FAIL = 'GET_CHATS_FAIL';
